import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { IncomingInvoiceTodoSelectionFormViewProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import { useWintForm, useWintExpandableStep, WintForm } from "components/common/wintForms";
import { useCostForwardingFormSync } from "components/costForwardingMarking";
import { Grid } from "@mui/material";

import { InternationalPaymentFormStep, RegularIncomingInvoiceFormStep } from "./_partialForms";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TodoSelectionForm: ForwardRefRenderFunction<FormHandles, IncomingInvoiceTodoSelectionFormViewProps> = (
  props,
  ref
) => {
  const {
    invoice,
    isInternationalPaymentView,
    bicRequired,
    defaultValues,
    validationSchema,
    handleSubmit,
  } = props;

  const { wintFormProps, connect, values, formState } = useWintForm<IncomingInvoiceFormTypes.Todo>({
    formRef: ref,
    defaultValues: defaultValues,
    validationSchema: validationSchema,
    handleSubmit: handleSubmit,
    enableReinitialize: true,
  });

  const expandableStepProps = useWintExpandableStep(formState);
  useCostForwardingFormSync(formState.setValues);

  return (
    <WintForm {...wintFormProps}>
      <Grid container className={cssExports.sectionedForm} marginBottom={-2.5}>
        {!isInternationalPaymentView ? (
          <RegularIncomingInvoiceFormStep
            connect={connect}
            values={values}
            expandableStepProps={expandableStepProps}
            incomingInvoiceProps={props}
            fileViewer={props.fileViewer}
          />
        ) : (
          <InternationalPaymentFormStep
            connect={connect}
            values={values}
            expandableStepProps={expandableStepProps}
            invoice={invoice}
            bicRequired={bicRequired}
          />
        )}
      </Grid>
    </WintForm>
  );
};

export default forwardRef(TodoSelectionForm);
